/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4"

export const APIErrorSchema = z.object({
  error: z.string().min(1),
})
